<template>
<v-dialog v-model="isVisible" scrollable max-width="600px">
    <v-card v-if="rawData">
        <v-row class="ma-0 pa-3" align="end" style="background: #3498db; color: white">
            <div>
                <div class="mb-2" style="font-size: 18px; font-weight: bold">{{ rawData.name }} ({{ rawData.code}})</div>
                <div style="font-size: 15px">{{ sort }} - {{ sectorData[rawData.sector] }}</div>
            </div>
            <v-spacer />
            <a style="color: white" target="_blank" v-if="rawData.link" :href="rawData.link">{{ date }} 사업보고서 보기</a>
        </v-row>

        <v-divider />
        <v-tabs grow v-model="tab">
            <v-tab>재무 비율</v-tab>
            <v-tab>재무 요약</v-tab>
        </v-tabs>
        <v-divider />

        <v-card-text class="ma-0 pa-0">
            <v-col v-if="tab == 0">
                <div class="pa-2 caption text-right" style="color: grey">
                    단위: 배
                </div>
                <v-divider />
                <v-row v-for="key in ratioKeys" :key="key">
                    <v-col class="text-center ma-1 pa-1">{{ $t(key) }}</v-col>
                    <v-col class="text-center ma-1 pa-1">{{ formatString(rawData[key], 1) }}</v-col>
                </v-row>
                <div class="pa-2 caption text-right" style="color: grey">
                    단위: %
                </div>
                <v-divider />
                <v-row v-for="key in percentKeys" :key="key">
                    <v-col class="text-center ma-1 pa-1">{{ $t(key) }}</v-col>
                    <v-col class="text-center ma-1 pa-1">{{ formatString(rawData[key], 1) }}</v-col>
                </v-row>
            </v-col>
            <v-col v-else>
                <div class="pa-2 caption text-right" style="color: grey">
                    단위: 억 원(KRW)
                </div>
                <v-divider />
                <v-row v-for="key in financialKeys" :key="key">
                    <v-col class="text-center ma-1 pa-1">{{ $t(key) }}</v-col>
                    <v-col class="text-center ma-1 pa-1">{{ formatString(rawData[key], 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</v-col>
                </v-row>
                <v-divider />
                <v-row v-for="key in incomeKeys" :key="key">
                    <v-col class="text-center ma-1 pa-1">{{ $t(key) }}</v-col>
                    <v-col class="text-center ma-1 pa-1">{{ formatString(rawData[key], 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</v-col>
                </v-row>
                <v-divider />
                <v-row v-for="key in cashKeys" :key="key">
                    <v-col class="text-center ma-1 pa-1">{{ $t(key) }}</v-col>
                    <v-col class="text-center ma-1 pa-1">{{ formatString(rawData[key], 0).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</v-col>
                </v-row>
            </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
            <v-spacer />
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    sectorData
} from '@/constants'

export default {
    name: 'finance-dialog',
    data() {
        return {
            isVisible: false,
            rawData: '',
            tab: 0,
            financialKeys: ["current_asset", "fixed_asset", "total_asset", "current_liability", "fixed_liability", "total_liability", "total_equity"],
            incomeKeys: ["sales", "sales_cost", "gross_profit", "selling_expense", "operating_income", "income_before_tax", "tax", "net_income", "owner_income"],
            cashKeys: ["operating_cash", "investing_cash", "financing_cash", "beginning_cash", "end_cash"],
            ratioKeys: ["per", "pbr", "psr", "pcr"],
            percentKeys: ["gpa", "op", "profit", "roe", "roa", "debt", "ncav"],
        }
    },
    computed: {
        sectorData() {
            return sectorData
        },
        date() {
            if (!this.rawData.date) return ''
            return new Date(this.rawData.date).toISOString().substring(0, 7)
        },
        sort() {
            return this.rawData.market == 0 ? '코스피' : '코스닥'
        }
    },
    methods: {
        show(rawData) {
            this.rawData = rawData
            this.isVisible = true
        },
        close() {
            this.isVisible = false
        },
        formatString(value, limit) {
            if (!value) return ''

            return value.toFixed(limit)
        },
    }
}
</script>
